import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import * as AppActions from '../../../redux/app/actions'


class MLTextAreaContainer extends Component {
    static propTypes = {
        placeholder:PropTypes.string,
        onChange:PropTypes.func,
        className:PropTypes.string,
        disableTranslate:PropTypes.bool,
        value:PropTypes.string
    };
    static defaultProps = {
        placeholder:"",
        onChange:()=>{},
        className:"",
        disableTranslate:false,
        value:""
    };

    

   

    render = () => {
        return (
            <textarea
               placeholder={(this.props.disableTranslate===false?AppActions.getFiledValue(this.props.language,this.props.placeholder):this.props.placeholder)}
               onChange={this.props.onChange}
               className={this.props.className}
               value={this.props.value}
            />
        )
    }

}

const mapStateToProps = state => ({
    language:state.app.language
});

// Any actions to map to the component?
const mapDispatchToProps = {

};
/* Export Component ==================================================================== */
export default connect(mapStateToProps, mapDispatchToProps)(MLTextAreaContainer);